// Copyright (c) 2019 Deere & Company

import NotificationLanguagePair, { getDefaultState as getNotificationLanguageDefaultPairState } from './notificationLanguagePair';
import t from 'tcomb';

const Notifications = t.list(NotificationLanguagePair, 'Notifications');

export const getDefaultState = () => new Notifications([getNotificationLanguageDefaultPairState()]);

export default Notifications;
